import {ISectionGroup, IPouchRows, ISectionLookupCache} from "shared-types/index";
import PouchLoadService from "external-services/pouch-load-service";
import { orderBy } from "lodash-es";
import { ISectionOptions } from "./type";

class SectionGroupsService {

  private trackEvent?: (eventName: any, values?: any) => void;

  setup(trackEvent?: (eventName: any, values?: any) => void) {
    this.trackEvent = trackEvent;
  }

  getSectionGroups(): Promise<ISectionGroup[]> {
    return Promise.resolve(PouchLoadService.getDbLocal().allDocs({
      include_docs: true,
      attachments: false,
      startkey: 'section-group_',
      endkey: 'section-group_\uffff'
    }).then((sectionGroups: unknown) => {
      return (sectionGroups as IPouchRows<ISectionGroup>).rows.map(function (item: {doc: ISectionGroup}) {
        return item.doc;
      });
    }));
  }

  saveSectionGroup(sectionGroup: ISectionGroup): Promise<PouchDB.Core.Response> {
    this.trackEvent && this.trackEvent('Save Section Group');
    if (!sectionGroup._id) {
      sectionGroup._id = PouchLoadService.getNewId(['section-group']);
    }
    return Promise.resolve(PouchLoadService.getDbLocal().put(sectionGroup));
  }

  saveSectionGroups(sectionGroups: ISectionGroup[]): Promise<(PouchDB.Core.Response | PouchDB.Core.Error)[]> {
    this.trackEvent && this.trackEvent('Save Sections');
    return Promise.resolve(PouchLoadService.getDbLocal().bulkDocs(sectionGroups));
  }

  deleteSectionsGroup(sectionGroups: ISectionGroup): Promise<PouchDB.Core.Response> {
    return Promise.resolve(PouchLoadService.getDbLocal().remove(sectionGroups as unknown as PouchDB.Core.RemoveDocument));
  }


  getSectionOptions(sectionsLookup: ISectionLookupCache, sectionGroups: ISectionGroup[], sectionIds: string[]): ISectionOptions[] {
    // const sectionIds = sectionGroups.map(({ _id }) => _id) // sectionIds is generated or passed from args?
    // eslint-disable-next-line prefer-const
    let sectionOptions: ISectionOptions[] = [
      {
        name: 'All',
        sectionIds: null // must be a falsy value
      }
    ];
    const sectionOptionsFromLookup = sectionIds.reduce((result: ISectionOptions[], sectionId: string) => {
      const foundInLookup: ISectionGroup = sectionsLookup[sectionId] as ISectionGroup;
      if (foundInLookup) {
        result.push({
          name: foundInLookup.name,
          sectionIds: [foundInLookup._id] // get _id or sectionIds ???
        });
      }
      return result
    }, sectionOptions)

    // console.debug({sectionOptionsFromLookup})

    // sectionOptionAlloweds contain sectionOptionsFromLookup
    const sectionOptionAlloweds = orderBy(sectionGroups, 'order', 'asc')
      .reduce((result: ISectionOptions[], sectionGroup: ISectionGroup) => {
        const allowed = sectionGroup.sectionIds.some(sectionId => sectionIds.includes(sectionId))
        if (allowed) { // Need to check if it is added from lookup already ???
          result.push({
            name: sectionGroup.name,
            sectionIds: sectionGroup.sectionIds
          });
        }
        return result
      }, sectionOptionsFromLookup)
    return sectionOptionAlloweds
  }
}

const instance = new SectionGroupsService();
export default instance as SectionGroupsService;
